'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialEuroOutline = function IoSocialEuroOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.2 5c-4.1 0-7.1 0.7-9 2.1-1.7 1.3-2.5 3.1-2.5 5.8v2.2h-3.9v1.2h3.9v6.3h-3.9v1.2h3.9v3.3c0 2.7 0.8 4.5 2.5 5.8 1.9 1.4 4.9 2.1 9 2.1 2.4 0 4.6-0.2 6.9-0.6l-0.4-2.8c-2.3 0.4-4.3 0.6-6.2 0.6-2.9 0-4.7-0.5-5.8-1.5-1.5-1.2-1.7-3.1-1.7-4.7v-2.2h9.3l0.3-1.2h-9.6v-6.3h10.5l0.2-1.2h-10.7v-1.5c0-1.3 0.2-3.1 1.7-4.3 1.2-1 3-1.5 5.8-1.5 1.8 0 3.9 0.2 6.2 0.6l0.4-2.8c-2.3-0.4-4.5-0.6-6.9-0.6z m0-1.2c2.8 0 5.3 0.2 8.3 0.9l-0.7 5.1c-2.9-0.5-5.3-0.7-7.3-0.7-5 0-6.2 1.7-6.2 4.5v0.2h10.8l-0.6 3.8h-10.2v3.7h9.7l-0.6 3.8h-9.1v0.9c0 3.5 1.2 4.9 6.2 4.9 2 0 4.4-0.2 7.3-0.7l0.7 5.1c-3 0.7-5.5 1-8.3 1-9 0-12.8-3.3-12.8-9.2v-2h-3.9v-3.8h3.9v-3.7h-3.9v-3.8h3.9v-0.9c0-5.9 3.8-9.1 12.8-9.1z' })
        )
    );
};

exports.default = IoSocialEuroOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-euro-outline.js
// module id = 2670
// module chunks = 0